import { render, staticRenderFns } from "./reclamosLeecheros.vue?vue&type=template&id=7dfe513c"
import script from "./reclamosLeecheros.vue?vue&type=script&lang=js"
export * from "./reclamosLeecheros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports